import { ReactNode } from 'react'
import styles from './HeaderContainerEthicalSavings.module.scss'

export type HeaderContainerEthicalSavingsProps = {
  children: ReactNode
}
export default function HeaderContainerEthicalSavings(
  props: HeaderContainerEthicalSavingsProps
): JSX.Element {
  const { children } = props
  return <div className={styles.container}>{children}</div>
}
